import React, {Component} from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import SlidingPanel from 'react-sliding-side-panel';
import {isMobile} from 'react-device-detect';
import Cart from "../components/Cart";
import {deleteUser, getUser} from "../auth/Auth";
import {getRequest} from "../routes/Routes";
import logo from '../assets/images/logo.png';
import '../assets/css/Header.css';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {user: null};
    }

    componentDidMount() {
        getUser().then(data => {
            this.setState({user: data});
        }).catch(() => null);
    }

    render() {
        let {user} = this.state;
        return (
            <header className="fixed-top navbar-header">
                <nav className="navbar navbar-expand-lg navbar-light container">
                    <NavLink className="navbar-brand" to="/">
                        <img src={logo} alt="Logo"/>
                    </NavLink>
                    <button className="navbar-toggler" type="button" data-toggle="collapse"
                            data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                            aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"/>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav mr-auto"/>
                        <ul className="navbar-nav navbar-links d-flex bd-highlight">
                            <li className="nav-item p-2 flex-fill bd-highlight" key="categories">
                                <NavLink className="nav-link" to="/categories" data-toggle="collapse"
                                         data-target="#navbarSupportedContent">Categories</NavLink>
                            </li>
                            <li className="nav-item p-2 flex-fill bd-highlight" key="partners">
                                <NavLink className="nav-link" to="/partners" data-toggle="collapse"
                                         data-target="#navbarSupportedContent">Partners</NavLink>
                            </li>
                            {!user ? [
                                <li className="nav-item p-2 flex-fill bd-highlight" key="login">
                                    <NavLink className="nav-link" to="/login" data-toggle="collapse"
                                             data-target="#navbarSupportedContent">Login</NavLink>
                                </li>,
                                <li className="nav-item p-2 flex-fill bd-highlight final-nav-item" key="signup">
                                    <NavLink className="nav-link sign-up-link" to="/signup" data-toggle="collapse"
                                             data-target="#navbarSupportedContent">
                                        <button className="btn my-2 my-sm-0 blue-border-button">
                                            Sign Up
                                        </button>
                                    </NavLink>
                                </li>
                            ] : [
                                <li className="nav-item dropdown p-2 flex-fill bd-highlight final-nav-item" key="admin">
                                    <NavLink className="nav-link dropdown-toggle" to="#" id="userDropdown"
                                             role="button" data-toggle="dropdown" aria-haspopup="true"
                                             aria-expanded="false">
                                        Hi, <span className="capital-text font-weight-bold">
                                        {user.first_name + ' ' + user.last_name}</span>
                                    </NavLink>
                                    <div className="dropdown-menu" aria-labelledby="userDropdown">
                                        <NavLink className="nav-link" to="/account" key="profile" data-toggle="collapse"
                                                 data-target="#navbarSupportedContent">Your Profile</NavLink>
                                        <NavLink className="nav-link" to="/account-settings" key="settings"
                                                 data-toggle="collapse" data-target="#navbarSupportedContent">
                                            Account Settings
                                        </NavLink>
                                        {user.role_id === 2 ? [
                                            <NavLink className="nav-link" to="/manage-store" key="store"
                                                     data-toggle="collapse" data-target="#navbarSupportedContent">
                                                Manage Store
                                            </NavLink>,
                                            <NavLink className="nav-link" to="/manage-orders" key="store-orders"
                                                     data-toggle="collapse" data-target="#navbarSupportedContent">
                                                Manage Orders
                                            </NavLink>,
                                        ] : user.role_id === 3 ? [
                                            <NavLink className="nav-link" to="/manage-users" key="users"
                                                     data-toggle="collapse" data-target="#navbarSupportedContent">
                                                Manage Users
                                            </NavLink>,
                                            <NavLink className="nav-link" to="/manage-partners" key="partners"
                                                     data-toggle="collapse" data-target="#navbarSupportedContent">
                                                Manage Partners
                                            </NavLink>,
                                            <NavLink className="nav-link" to="/manage-orders" key="orders"
                                                     data-toggle="collapse" data-target="#navbarSupportedContent">
                                                Manage Orders
                                            </NavLink>,
                                        ] : null}
                                        <NavLink className="nav-link" to="/login" onClick={this.logout}
                                                 key="logout" data-toggle="collapse"
                                                 data-target="#navbarSupportedContent">
                                            Sign out of <span
                                            className="font-weight-bold">{user.first_name + ' ' + user.last_name}</span>
                                        </NavLink>
                                    </div>
                                </li>
                            ]}
                            <li className="nav-item p-2 flex-fill bd-highlight final-nav-item" key="cart">
                                <button className="btn my-2 my-sm-0 blue-button"
                                        onClick={() => this.openCartComponent()} data-toggle="collapse"
                                        data-target="#navbarSupportedContent">
                                    Cart
                                </button>
                            </li>
                        </ul>
                    </div>
                </nav>
                <SlidingPanel type={'right'} isOpen={this.state.cartComponentOpen} size={isMobile ? 100 : 30}
                              backdropClicked={() => this.openCartComponent()}>
                    <div className="cart-component-container">
                        <div className="container cart-component-container-details">
                            <div className="d-flex bd-highlight w-100" key="div">
                                <div className="p-2 flex-fill bd-highlight">
                                    <h1 className="heading capital-text">Cart</h1>
                                </div>
                                <div className="p-2 flex-fill bd-highlight">
                                    <button type="button" className="close" aria-label="Close"
                                            onClick={() => this.openCartComponent()}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                            <hr/>
                            <Cart component="Header"/>
                        </div>
                    </div>
                </SlidingPanel>
                <form onSubmit={this.searchFunction} className="search-bar container">
                    <div className="input-group">
                        <input className="form-control no-border" id="search"
                               placeholder='Search Store' required/>
                        <div className="input-group-append">
                            <button className="btn blue-button">Go</button>
                        </div>
                    </div>
                </form>
            </header>
        );
    }

    logout = () => {
        deleteUser().then(() => this.setState({user: null})).catch(() => null);
    };

    openCartComponent = () => {
        this.setState({cartComponentOpen: !this.state.cartComponentOpen});
    }

    searchFunction = async (event) => {
        event.preventDefault();
        getRequest('/api/search/' + event.target.search.value).then(response => {
            if (response.status === 200) {
                if (this.props.location.pathname === '/search-results') {
                    this.props.history.go();
                }
                if (response.data.error) {
                    this.props.alert.error(response.data.message);
                } else {
                    this.props.history.push({
                        pathname: "/search-results",
                        state: {
                            results: response.data.results,
                            search: event.target.search.value
                        }
                    });
                }
            } else {
                this.props.alert.error(response.data.message);
            }
        });
    }
}

export default withRouter(Header);